import { render } from "./PaqueteCreate.vue?vue&type=template&id=225e6cb6&scoped=true"
import script from "./PaqueteCreate.vue?vue&type=script&lang=js"
export * from "./PaqueteCreate.vue?vue&type=script&lang=js"

import "./PaqueteCreate.vue?vue&type=style&index=0&id=225e6cb6&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225e6cb6"]])

export default __exports__